// routes/PdfTab.tsx
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { App } from 'antd';
import { storageUtil } from '@/utils/storage/local-storage.util';
import PdfWithBoxesReducto, { FieldHit, PageMeta } from './PdfWithBoxesReducto';

type Payload = {
  title?: string | null;
  base64: string;
  pages: PageMeta[];
  hits: Record<string, FieldHit | null>;
  scale?: number;
};

export default function PdfTab() {
  const [params] = useSearchParams();
  const key = params.get('key') ?? '';
  const [payload, setPayload] = useState<Payload | null>(null);

  useEffect(() => {
    if (!key) return;
    const data = storageUtil.getItem<Payload>(key);
    if (data) {
      setPayload(data);
      // remove immediately after we’ve copied to state
      storageUtil.removeItem(key);
    }
  }, [key]);

  // extra safety: if user closes tab quickly before React runs, try removing again
  useEffect(() => {
    return () => {
      if (key) storageUtil.removeItem(key);
    };
  }, [key]);

  if (!payload) return <div style={{ padding: 16 }}>Loading…</div>;

  return (
    <App>
      <div
        style={{
          height: '100vh',
          width: '100vw',
          overflow: 'auto',
          background: '#f5f5f5',
        }}
      >
        <div style={{ padding: 8, fontWeight: 600 }}>
          {payload.title ?? 'PDF Preview'}
        </div>
        <PdfWithBoxesReducto
          base64={payload.base64}
          pages={payload.pages}
          hits={payload.hits}
          scale={payload.scale}
        />
      </div>
    </App>
  );
}
